export default __webpack_public_path__ + "static/stonefit-8d437c0a9f65011e1e22fafa7aec5449.png";